<template>
  <div class="d-flex align-center">
    <div
      class="number-icon d-flex align-center justify-center"
      v-if="number != null"
    >
      {{ number }}
    </div>
    <div class="label">
      {{ text }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrderedItem',
  props: {
    number: {
      type: Number,
      default: null
    },
    text: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../styles/variables.scss';

.number-icon {
  border-radius: 50%;
  background: $ads-blue-1;
  color: $ads-white;
  min-width: 28px;
  height: 28px;
  font-weight: 700;
  margin: 0 8px 0 8px !important;
}

.label {
  margin-left: 8px;
  font-size: 1rem;
  color: $ads-dark;
}
</style>
